import {useNavigate, useParams} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';
import ChatHeaderIcon from '../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import NoItemFoundPage from '../../../components/noItemFoundPage';
import PageLoader from '../../../components/pageLoader';
import useGetCashBackHistoryList from './api/getCashBackHistoryList/useGetCashBackHistoryList';
import TransactionItemCard from './components/TransactionItemCard';

const CashbackTransactionLogs = () => {
  const navigate = useNavigate();
  const {cashBackGuid} = useParams();

  const {data, loaderRef, isFetchingNextPage, isLoading} =
    useGetCashBackHistoryList(cashBackGuid);

  if (isLoading) return <PageLoader />;

  if (data?.length === 0) return <NoItemFoundPage />;

  return (
    <div className="flex flex-col overflow-hidden bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">اعتبار من</span>
          </div>
        )}
        postComponent={() => (
          <div className="flex gap-3 ">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />
      <div className="flex flex-col flex-1 min-h-0 px-6">
        <h1 className="mt-6 mb-2 text-sm font-medium text-right text-gray-700 ">
          جزئیات مبلغ اعتبار
        </h1>
        <div className="flex flex-col gap-2 overflow-y-auto max-h-[38rem]">
          {data?.map(transaction => (
            <TransactionItemCard
              key={transaction?.guid}
              transaction={transaction}
            />
          ))}
          {/* This div acts as a sentinel for triggering infinite scroll */}
          <div ref={loaderRef} className="mt-4 text-center">
            {isFetchingNextPage ? <DotsLoading /> : null}
          </div>
        </div>
        <div className="pt-2 pb-6 mt-auto ">
          <button
            type="button"
            className="h-12 w-full rounded-lg bg-[#4d8f12] text-sm font-medium text-white transition-colors hover:bg-[#437d0f]"
            onClick={() => navigate(-1)}
          >
            بستن
          </button>
        </div>
      </div>
    </div>
  );
};

export default CashbackTransactionLogs;
